import React, { Fragment, useCallback, useContext, useEffect } from 'react';
import { CommonOfferProps } from '@components/types';
import { logUserEvent } from '@analytics/amplifyLogging';
import { AmplifyLogs } from '@constants';
import { WidgetsContext } from '@context';
import { Offer } from '@types';
import { extractOfferType } from '@utils/offers-utils';
import { CommonOfferCard, EventType } from 'shared-ui-components';
import { useDispatch, useSelector } from 'react-redux';
import { setParentModal } from '@store/actions/lip.action';
import { useNavigate } from 'react-router-dom';
import { getFullAppFeatureFlags } from '@store/reducers/config.reducer';
import { get } from 'lodash';

const CommonOfferWrapper: React.FC<CommonOfferProps> = ({ navigationType, offers }) => {
    const { getOfferReponse, loanNumber } = useContext(WidgetsContext);
    const dispatch = useDispatch();

    const flags = useSelector(getFullAppFeatureFlags);

    const navigate = useNavigate();
    const handleNavigation = (offerType: string, response: Offer) => {
        getOfferReponse(response);
        // navigationType(extractOfferType(offerType));

        if (response && get(flags, [response.product_Campaign], false)) {
            navigate(`fullapp/${loanNumber}`, { state: { offer: response, offerType: offerType, loanNumber: loanNumber } });
        } else {
            navigationType(extractOfferType(offerType));
        }

        logUserEvent({
            ...AmplifyLogs[extractOfferType(offerType)],
            loanNumber,
            type: 'CommonOffer Wrapper Component'
        });
    };

    useEffect(() => {
        offers.map(({ offerType }: any) => {
            logUserEvent({
                action: 'Offer Displayed',
                description: `${offerType} - Offer displayed`,
                type: 'CommonOffer Wrapper Component',
                loanNumber
            });
        });
    }, [loanNumber]);

    const userEvents = useCallback((event: EventType) => {
        logUserEvent({
            action: event.action,
            description: event.description,
            type: 'CommonOffer Wrapper Component',
            loanNumber
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {Array.isArray(offers) &&
                offers.length > 0 &&
                offers?.map(({ template, offerDetails, offerType }) => (
                    <Fragment key={template}>
                        <CommonOfferCard
                            card={template}
                            requestedBy={'ACP'}
                            logUserEvent={userEvents}
                            onDeepLink={(link: string) => {
                                if (link === 'od') {
                                    dispatch(setParentModal({ showModal: true, payload: offerType, component: 'OfferDisclosures' }));
                                } else if (['co', 'pu', 'rt', 'sl'].includes(link)) {
                                    handleNavigation(offerType, offerDetails);
                                }
                            }}
                            cardType={offerType}
                        />
                    </Fragment>
                ))}
        </>
    );
};

export default React.memo(CommonOfferWrapper);
